import feedbackService from '../../service/feedback-service'

export const actionTypes = {
    LOADREQ: 'FEEDBACK LOAD REQ',
    RECEIVED: 'FEEDBACK DATA RECEIVED',
    SUBMITREQ: 'FEEDBACK SUBMIT REQ',
    SUBMITDONE: 'FEEDBACK SUBMIT RSP',
    ERROR: "FEEDBACK ERROR",
    NEXT: "FEEDBACK NEXT QUESTION",
    LANGUAGE:"CHANGE LANGUAGE"
}

// // {patientId, billingId}
export function fetchFeedbackIfNeeded(req) {
    return (dispatch, getState) => {
        if (shouldFetchFeedbackquestions(getState(), req)) {
            // return feedbackService.getquestions(req)
            return feedbackService.getHindiQuestion(req)
                .then(json => dispatch(receiveFeedbackAction(json)))
                .catch(error => dispatch(errorAction(error)))
        }
    }
}

export function shouldFetchFeedbackquestions(state, req){
    if (state.questions){
        return false;
    }
    return true;
}
// export const load = (req) => dispatch => {
//     dispatch(loadFeedbackAction(req))

// }

export const submit = (patientId, feedback) => dispatch => {
    dispatch({ type: actionTypes.SUBMITREQ, ts: Date.now() })
    feedbackService.submit(req)
        .then(json => dispatch({ type: actionTypes.SUBMITDONE, json }))
        .catch(error => dispatch(errorAction(error)))
}

// export const incrementCount = () => dispatch => {
//   return dispatch({ type: actionTypes.INCREMENT })
// }

export const selectNextQuestion = (currentIndex) => dispatch => {
    return dispatch({
        type: actionTypes.NEXT,
        currentIndex
    })
}

function errorAction(error) {
    return {
        type: actionTypes.ERROR,
        message: error.message
    }
}

// {patientId, billingId}
// function loadFeedbackAction(req) {
//     return {
//         type: actionTypes.LOADREQ,
//         req: req,
//         receivedAt: Date.now()
//     }
// }
export const loadFeedbackAction = (req) => dispatch => {
    dispatch({ type: actionTypes.LOADREQ, ts: Date.now() })
    feedbackService.submit(req)
        .then(json => dispatch({ type: actionTypes.RECEIVED, json }))
        .catch(error => dispatch(errorAction(error)))
}


function receiveFeedbackAction(json) {
    return {
        type: actionTypes.RECEIVED,
        questions: json, //json.data.children.map(child => child.data),
        receivedAt: Date.now()
    }
}

export const changeLanguage = (questionsData) => dispatch => {
    return dispatch({ type: actionTypes.LANGUAGE, questionsData: questionsData, ts: Date.now() })
}


/**
 * function fetchPosts(subreddit) {
  return dispatch => {
    dispatch(requestPosts(subreddit))
    return fetch(`https://www.reddit.com/r/${subreddit}.json`)
      .then(response => response.json())
      .then(json => dispatch(receivePosts(subreddit, json)))
  }
}

 */


// WEBPACK FOOTER //
// store/feedback/action.ts